// apps/web/src/ui/notify.ts
export function notify(message: string) {
    window.dispatchEvent(new CustomEvent("bt:notify", { detail: { message } }));
}
